<p-tieredMenu
  #menu
  [model]="menuItems"
  [popup]="popup"
  class="max-h-[80vh]"
  styleClass="max-h-[80vh]"
  appendTo="body"
></p-tieredMenu>
